import { pList, rMadenSahalariBilgi, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';
import { rMadenSahalariBilgi_RawData } from '../../../../api/models/rMadenSahalariBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_MADENSAHALARIBILGI,
    new Api.Bilgi.MadenSahalariBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rMadenSahalariBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rMadenSahalariBilgi> =>
  ActionFunctions.action_async_complete_api<rMadenSahalariBilgi>(
    ActionSubTypes.API_MADENSAHALARIBILGI,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
